<template>
  <vxe-modal v-model="visible" :destroyOnClose="true" :loading="loading" :title="$t('title.detailInvert')" show-footer size="mini" type="confirm" width="50%" @cancel="cancel" @confirm="confirm">
    <a-form-model ref="form" :colon="false" :label-col="labelCol" :model="detail" :wrapper-col="wrapperCol">
      <a-row style="margin-left: -4%;margin-right: 4%">
        <a-col :span="12">
          <a-form-model-item :label="$t('business.label.itemNo')">
            <a-input v-model="detail.item.no" disabled/>
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item :label="$t('business.label.itemName')">
            <a-input v-model="detail.item.name" disabled/>
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item :label="$t('business.label.specification')">
            <a-input v-model="detail.pack.specification" disabled/>
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item :label="$t('business.label.uom')">
            <a-input v-model="detail.pack.uom" disabled/>
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item :label="$t('business.label.factor')">
            <a-input v-model="detail.pack.factor" disabled/>
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item :label="$t('business.label.plannedQuantity')">
            <a-input v-model="detail.plannedQuantity" disabled/>
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item :label="$t('business.label.actualQuantity')">
            <a-input v-model="detail.actualQuantity" disabled/>
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item :label="$t('business.label.inverseQuantity')">
            <a-input-number v-model="inverseQuantity" :defaultValue="0" :max="detail.plannedQuantity" :min="0" :placeholder="$t('business.label.inverseQuantity')" style="width: 100%" type="number" @change="change"/>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
  </vxe-modal>
</template>

<script>
import Vue from 'vue'
import { ENTERPRISE } from '@/store/mutation-types'
import { post } from '@/api/Api'
import { ShipmentDetail } from '@/api/dto/order/ShipmentOrder'
import { BaseObject } from '@/api/dto/BaseObject'
import api from '@/api'

export default {
  name: 'DetailInversionEditor',
  data() {
    return {
      enterprise: Vue.ls.get(ENTERPRISE),
      visible: false,
      loading: false,
      detail: new ShipmentDetail(),
      inverseQuantity: 0,
      labelCol: { span: 8 },
      wrapperCol: { span: 16 }
    }
  },
  props: {
    directions: {
      type: Array,
      default: () => []
    },
    idTypes: {
      type: Array,
      default: () => []
    },
    regions: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    open(record) {
      this.detail = new ShipmentDetail(BaseObject.merge(record, 'detail'))
      this.inverseQuantity = parseFloat(this.detail.plannedQuantity) - parseFloat(this.detail.actualQuantity)
      this.visible = true
    },
    change() {
      this.detail.actualQuantity = parseFloat(this.detail.plannedQuantity) - parseFloat(this.inverseQuantity)
    },
    confirm() {
      this.$refs.form.validate(() => {
        this.loading = true
        const args = [{ id: this.detail.id, actualQuantity: this.detail.actualQuantity }]
        post(api.dispatchInvertDetail, {}, { details: args }).then(res => {
          if (res.success) {
            this.$message.success('冲红成功')
            this.$emit('success')
            this.visible = false
          }
        }).finally(() => this.loading = false)
      })
    },
    cancel() {
      this.detail = new ShipmentDetail()
      this.visible = false
    }
  }
}
</script>